/*
 * @Author: Q in 
 * @Date: 2026-06-10 17:30:19
 * @LastEditors: Q in 
 * @LastEditTime: 2026-06-13 14:24:56
 * @FilePath: /new_kefu_pc/src/api/upload.js
 * @Description: 上传文件
 */
//引入axios
import request from '@/utils/index-request';

export function fetchAliyunOssToken(data) {
	return request({
		url: '/api/aliyun_oss/getOssToken',
		method: 'post',
		data // 一般post请求，我们习惯使用 data属性来传参
	});
}

export function fetchAliyunOssParams(data) {
	return request({
		url: '/addons/alioss/index/params',
		method: 'post',
		data // 一般post请求，我们习惯使用 data属性来传参
	});
}